'use client';

import * as React from 'react';

var CircleChecked = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: 16, cy: 16, r: 15.25, fill: "white", stroke: "#005AFF", strokeWidth: 1.5 }),
        React.createElement("path", { d: "M10.1665 16.834L13.4998 20.1673L21.8332 11.834", stroke: "#005AFF", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
var CircleChecked$1 = React.memo(CircleChecked);

export { CircleChecked$1 as default };
//# sourceMappingURL=index.js.map
